import { ReportFeatures } from '@hcs/types';

export const AVM_BREAKDOWN_FEATURES = [ReportFeatures.AvmBreakdown];
